import { IColumns } from '../../../components/Table'

export type SettingsUsersColumnsType = 'name' | 'description' | 'active' | 'createdAt'

export const columns: IColumns<SettingsUsersColumnsType>[] = [
  {
    id: 'name',
    label: 'Name',
  },
  {
    id: 'description',
    label: 'Description',
  },
  {
    id: 'active',
    label: 'Active',
  },
  {
    id: 'createdAt',
    label: 'CREATED AT',
    format: (value) =>
      value
        ? new Date(value as Date).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
        : '-',
  },
]
